<template>
    <div class="expandable-image" :class="{ expanded }" @click="expanded = true">
      <close-icon class="close-button" v-if="expanded"></close-icon>
      <arrow-expand-icon class="expand-button" v-else></arrow-expand-icon>
      <img v-bind="$attrs" @error="loadErrorHandler" @load="loadedHandler" @contextmenu.prevent/>
      <span class="photo-credit" v-if="hasCredit">Photos by {{ $attrs["data-credit"] }}</span>
    </div>
</template>

<script>
import CloseIcon from 'vue-material-design-icons/Close.vue';
import ArrowExpandIcon from 'vue-material-design-icons/ArrowExpand.vue';
import { LoggingService } from "@/services/ApiService.js";

export default {
  components: {
    CloseIcon,
    ArrowExpandIcon
  },
    inheritAttrs: false,
    data () {
        return {
          expanded: false,
          closeButtonRef: null
        }
    },
    mounted: function () {
      this.errorHandlerCleanUp();
    },
    computed: {
      isCover: function () {
        return this.$attrs["data-cover"] == "true";
      },
      hasCredit: function () {
        return this.$attrs["data-credit"];
      }
    },
    methods: {
      errorHandlerCleanUp () {
        // Remove any fallback images left over before DOM is ready for a clean start
        document.getElementsByClassName("img-fallback").forEach(elem => {
          elem.remove();
        });        
      },
      closeImage (event) {
        this.expanded = false
        event.stopPropagation();
      },
      disableContextMenu (event) {
        event.preventDefault();
      },
      loadedHandler() {
        // Make sure img is displayed when loaded
        this.$el.style.display = "block";
      },
      loadErrorHandler() {
        const img = this.$el; 
        img.style.display = "none";
        let imgSrc = img.getElementsByTagName("img")[0].src;

        // Check if fallback already exists and remove it if so to avoid funny business
        let fallBackElements = document.getElementsByClassName("img-fallback");
        fallBackElements.forEach(element => {
          if (element.dataset.src == imgSrc) {
            document.removeChild(element);
          }
        });

        const imgFallback = document.createElement("div");
        imgFallback.className = "img-fallback";
        imgFallback.innerHTML = "<p>Sorry, this image seems to be broken :(</p>"
        imgFallback.dataset.src = imgSrc;
        imgFallback.style.width = img.width ? img.width + "px" : "auto";
        imgFallback.style.height = img.height ? img.height + "px" : "90%";
        imgFallback.style.marginTop = "20px";

        img.parentNode.insertBefore(imgFallback, img.nextSibling);     
        
        LoggingService.log("ExpandableImage", "Error loading image: " + imgSrc, null);
      },
    },    
    watch: {
        expanded (expanded) {
            this.$nextTick(() => {
            // Run this if when we're expanding the image
            if (expanded) {
                // Clone the entire expandable-image element
                this.cloned = this.$el.cloneNode(true)
                // Manually prevent contextmenu
                this.cloned.addEventListener('contextmenu', this.disableContextMenu);         
                // Store a reference for the close button
                this.closeButtonRef = this.cloned.querySelector('.close-button')
                // Call closeImage when the close button is clicked
                this.closeButtonRef.addEventListener('click', this.closeImage)
                // Add the cloned element into <body>
                document.body.appendChild(this.cloned)
                // Prevent the page from scrolling
                document.body.style.overflow = 'hidden'
                setTimeout(() => {
                // Show the cloned element
                this.cloned.style.opacity = 1
                }, 0)
            } else {
                // This section will run when the image is closing
                // Hide the expanded image
                this.cloned.style.opacity = 0
                setTimeout(() => {
                // Then, remove the click event listener from the close button
                this.closeButtonRef.removeEventListener('click', this.closeImage)
                // Remove the cloned element and the references
                this.cloned.removeEventListener('contextmenu', this.disableContextMenu);                
                this.cloned.remove()
                this.cloned = null
                this.closeButtonRef = null
                // Re-enable the scrolling
                document.body.style.overflow = 'auto'
                }, 250)
            }
            })
        }
    }
}
</script>

<style lang="less" scoped>
.photo-credit {
  display: block;
  text-align: right;
  font-size: 0.85rem;
  margin-top: 5px;
}
.expandable-image {
  position: relative;
  transition: 0.25s opacity;
  cursor: zoom-in;
}
body > .expandable-image.expanded {
  position: fixed;
  z-index: 999999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #000000f0;
  display: flex;
  align-items: center;
  opacity: 0;
  padding-bottom: 0 !important;
  cursor: default;
}
body > .expandable-image.expanded > img {
  max-height: 100%;
  object-fit: contain;
  margin: 0 auto;
  border-radius: 2px;
}
body > .expandable-image.expanded > .close-button {
  display: block;
}
.close-button {
  position: fixed;
  top: 30px;
  right: 30px;
  display: none;
  cursor: pointer;
  color: #ffffff;
  font-size: 36px;
  padding: 10px;
  background-color: var(--accent);
  border-radius: 2px;
  svg {
    position: static;
  }
}
.expand-button {
  font-size: 24px;
  color: #ffffff;
  position: absolute;
  z-index: 999;
  right: 10px;
  top: 10px;
  padding: 0px;
  align-items: center;
  justify-content: center;
  padding: 3px;
  opacity: 0;
  transition: 0.2s opacity;
}
.expandable-image:hover .expand-button {
  opacity: 1;
}
.expandable-image img {
  width: 100%;
  border-radius: 2px;
};
.z-1 {
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
}
.z-5 {
  box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22) !important;
}
</style>